<mat-card class="mat-card-element-force-relative">
    <h3 mat-dialog-title class="title">{{ data.title }}</h3>
    <a class="icon-link" (click)="onClose()" matTooltip="Close Item"><mat-icon>close_small</mat-icon></a>
  <form [formGroup]="regExpForm" class="regexp-form mat-form-field-input-description">
    <mat-label class="mat-label-position-absolute">Regular expression input (first matched group will be used)</mat-label>
    @if (regExpForm.get('regExpInput'); as ctrl) {
      <mat-form-field>
        <mat-label>RegExp:</mat-label>
        <input matInput formControlName="regExpInput" />
        <mat-hint>{{ data.regexpHint }}</mat-hint>
        @if (ctrl?.hasError('required')) {
          <mat-error
            ><!--
            -->Regular expression is required
          </mat-error>
        }
        @if (ctrl?.hasError('invalidRegExp')) {
          <mat-error
            ><!--
            -->{{ ctrl?.getError('invalidRegExp') }}
          </mat-error>
        }
      </mat-form-field>
    }
    <mat-label class="mat-label-position-absolute">Regular expression verification</mat-label>
    <mat-form-field>
      <mat-label>Subject:</mat-label>
      <input matInput formControlName="regExpTestInput" />
      @if (regExpTestInputSuccess) {
        <mat-hint>{{ regExpTestInputSuccess }}</mat-hint>
      }
      @if (regExpTestInputFailure) {
        <mat-hint>{{ regExpTestInputFailure }}</mat-hint>
      }
      @if (!regExpTestInputSuccess && !regExpTestInputFailure) {
        <mat-hint>{{ data.caseNameHint }}</mat-hint>
      }
    </mat-form-field>
  </form>
  <mat-dialog-actions class="footer" align="end">
    <button mat-button mat-raised-button [color]="data.button1.style.color" (click)="onButton1Click()">{{ data.button1.text }}</button>
    <button mat-button mat-stroked-button [color]="data.button2.style.color" (click)="onButton2Click()">{{ data.button2.text }}</button>
    <button mat-button mat-raised-button [color]="data.button3.style.color" (click)="onButton3Click()">{{ data.button3.text }}</button>
  </mat-dialog-actions>
</mat-card>
